// @ts-nocheck
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import {
    chain,
    LoadCart as baseLoadCart,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";
import {
    createChainHandler,
    executeAwaitableHandlerChain,
    replaceInChain,
} from "@toolkit/Modules/client-framework/HandlerCreator";

export const LoadCart = createChainHandler("LoadCart", chain, async props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    if (cartId) {
        await executeAwaitableHandlerChain<Parameters<typeof loadCart>[0], ReturnType<ReturnType<typeof loadCart>>>(
            loadCart,
            { cartId },
            props,
        );
    } else {
        await executeAwaitableHandlerChain<
            Required<Parameters<typeof loadCurrentCart>>[0],
            ReturnType<ReturnType<typeof loadCurrentCart>>
        >(loadCurrentCart, { getPromotions: true }, props);
    }
});

replaceInChain(chain, baseLoadCart, LoadCart);
